module.exports = __webpack_public_path__ + "static/integrations-tech-mobile-0182721ba875c4ecd81df9d9703613a6.png";